module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Kitchenaid-b2718e1fdc35c1cec8868497f5bb3a92.png";